import { render, staticRenderFns } from "./cassso.vue?vue&type=template&id=25da790a&scoped=true&"
import script from "./cassso.vue?vue&type=script&lang=js&"
export * from "./cassso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25da790a",
  null
  
)

export default component.exports